export enum EUnitColumn {
    UNIT_STATUS = 'unitStatus',
    UNIT_NAME = 'unitName',
    FLOOR_PLAN_AREA = 'floorPlanArea',
    UNIT_PRICE = 'unitPrice',
    BEDROOM_COUNT = 'bedRoomCount',
    PRICE_PSF = 'pricePsf',
    FLOOR_PLAN_NAME = 'floorPlanName',
    UNIT_TYPE_TITLE = 'unitTypeTitle', // assuming "un" is for unit number
}


export enum EUnitTransactionStatus {
    SOLD = "sold",
    AVAILABLE = "available",
}